<template>
  <div class="background" :style="'background-image: url(' + Background + ')'">
    <challenges-mobile
      v-if="isMobile"
      :time-elapsed="timeElapsed"
      :challenges="displayedChallenges"
      :selectedTab="selectedTab"
      @selectTab="selectTab"
    />
    <challenges-desktop
      v-else
      :time-elapsed="timeElapsed"
      :challenges="displayedChallenges"
      :selectedTab="selectedTab"
      @selectTab="selectTab"
    />
  </div>
</template>

<script>
  import Background from '@/assets/Background.png';
  import { mapState } from 'vuex';
  import ChallengesController from '@/controllers/ChallengesController';

  export default {
    name: 'Homes',

    components: {
      ChallengesDesktop: () => import('./ChallengesDesktop.vue'),
      ChallengesMobile: () => import('./ChallengesMobile.vue'),
    },

    props: ['isMobile'],

    data: () => ({
      challenges: [],
      Background,
      timeElapsed: 0,
      timerInterval: undefined,
      timeLimit: 10000,
      selectedTab: 0,
    }),

    computed: {
      ...mapState({
        tokens: (state) => state.tokens,
      }),
      displayedChallenges() {
        const date = new Date();
        switch (this.selectedTab) {
          case 0:
            return this.challenges.filter(
              (challenge) => new Date(challenge.expiryDate) > date
            );
          case 1:
            return this.challenges.filter(
              (challenge) => new Date(challenge.expiryDate) <= date
            );
          case 2:
            return this.challenges.filter(
              (challenge) =>
                new Date(challenge.expiryDate) <= date &&
                this.challengeIsCompleted(challenge)
            );
          default:
            return null;
        }
      },
    },

    mounted() {
      this.getChallenges();
      this.startTimer();
    },

    methods: {
      getChallenges: async function() {
        try {
          const challenges = await ChallengesController.getChallenges();
          challenges.forEach((challenge) => {
            if (challenge.imageUrl) {
              challenge.image = challenge.imageUrl;
            }
          });
          this.challenges = challenges;
        } catch (err) {
          this.$emit('handleError', err);
        }
      },
      startTimer() {
        this.timerInterval = setInterval(() => {
          if (++this.timeElapsed === this.timeLimit) {
            clearInterval(this.timerInterval);
          }
        }, 1000);
      },
      selectTab: function(tab) {
        this.selectedTab = tab;
      },
      challengeIsCompleted: function(challenge) {
        var isCompleted = true;
        challenge.moments.forEach((moment) => {
          if (!isCompleted) {
            return;
          }
          const momentId = moment._id.toString();
          const hasToken =
            this.tokens.filter(
              (token) => token.moment._id.toString() === momentId
            ).length > 0;
          if (!hasToken) {
            isCompleted = false;
            return;
          }
        });
        return isCompleted;
      },
    },
  };
</script>

<style scoped></style>
